import { useContext } from 'react';
import { merge } from 'lodash';
import * as Api from '~/App/Api/Users';

import UserContext from '~/App/Contexts/UserContext';
import { UseQueryOptions } from 'react-query';
import { AxiosError } from 'axios';

interface QueryOptions
  extends UseQueryOptions<Api.GetUserResponse, AxiosError> {
  refreshPageOnUserLoggedOut?: boolean;
}

export interface UseCurrentUserOptions {
  queryOptions?: QueryOptions;
}

export default function useCurrentUser(options?: UseCurrentUserOptions) {
  const initialData = useContext(UserContext);

  const { refreshPageOnUserLoggedOut = false, ...queryOptions } =
    options?.queryOptions ?? {};
  const { data: user } = Api.useCurrentUser({
    initialData,
    onError: (err) => {
      // if the user cannot get their own details
      // they are no longer logged into the API
      // i.e. their API token has expired
      if (err.response?.status === 401 && refreshPageOnUserLoggedOut) {
        window.location.reload();
      }
    },
    refetchOnWindowFocus: 'always',
    refetchIntervalInBackground: true,
    ...queryOptions,
  });

  return merge(initialData, user ?? {});
}
